var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 119,
    viewBox: "0 0 129 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2665 90.1385C110.285 88.0644 128.323 68.7194 128.323 45.1613C128.323 20.2194 108.103 0 83.1613 0C63.9911 0 47.6106 11.9444 41.0561 28.797C18.038 30.8711 0 50.2161 0 73.7742C0 98.7161 20.2194 118.935 45.1613 118.935C64.3315 118.935 80.712 106.991 87.2665 90.1385ZM83.1613 90.3226C84.5451 90.3226 85.9144 90.2603 87.2665 90.1385C89.2399 85.0646 90.3226 79.5459 90.3226 73.7742C90.3226 48.8323 70.1032 28.6129 45.1613 28.6129C43.7775 28.6129 42.4082 28.6752 41.0561 28.797C39.0827 33.8709 38 39.3896 38 45.1613C38 70.1032 58.2194 90.3226 83.1613 90.3226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.785b5403c04d8de68ed598d564ba8265.svg";
export { ForwardRef as ReactComponent };